import React, { FC } from 'react';
import { PageTitle, PageLink } from '../../../_mexablock/layout/core';
import { View } from './components/View';

const breadCrumbs: Array<PageLink> = [];

const CallCenterPage: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Call Center</PageTitle>
      <View />
    </>
  );
};

export { CallCenterPage };
